import * as React from "react";
import { Route, useLocation } from "react-router";

import { getUserFromStorage, MessageChecker, telemetryService } from "../../";
import { Routing } from "../../domain";
import {
    MessageCheckerProvider,
} from "../../features/messages/messageChecker/messageCheckerProvider";

export const AuthenticatedRoute = ({
    component: Component,
    appName,
    ...others
}) => {
    const location = useLocation();
    const hasLoggedIn = React.useRef(false);
    const user = getUserFromStorage();
    const hasAccess = () => {
        if (location.pathname.startsWith(`/${appName}/public`)) {
            return true;
        }

        const canAccess = !!user && user.applicationName === appName;
        if (canAccess && hasLoggedIn.current === false) {
            hasLoggedIn.current = true;
            telemetryService.userLogin({
                email: user.email,
                applicationName: user.applicationName,
                fullName: user.displayName,
                roleId: user.roleId,
            });
        }
        return canAccess;
    };

    const app = props => (
        <MessageCheckerProvider>
            <Component {...props} />
            <MessageChecker />
        </MessageCheckerProvider>
    );

    if (!hasAccess()) {
        const logInfo = {
            app: appName,
            hasUser: !!user,
            userApp: user?.applicationName ?? "no application on user",
            userEmail: user?.email ?? "no user email",
            expires: user?.expires ?? "no expiration",
            token: user?.token ?? "no token",
        };

        console.warn("Authenticated Route: does not have access", logInfo);
        telemetryService.trackEvent("Authenticated Route No Access", logInfo);

        localStorage.setItem("relode:redirectUrl", window.location.href);
        window.location.href = Routing.Account.SIGNIN + `?appName=${appName}`;
        return null;
    }

    return <Route {...others} render={props => app(props)} />;
};
